import { ObstetricalExamResultState } from "@/Patient/Models/ObstetricalFile/ObstetricalExamResultState";

class ObstetricalExamResultData<T> {
    public Result: ObstetricalExamResultState = ObstetricalExamResultState.NotDone;
    public ExtraInfo: T;

    public constructor(fields?: Partial<ObstetricalExamResultData<T>>) {
        Object.assign(this, fields);
    }

    public setNormalResultIfNothingSet(): void {
        this.Result = !this.Result
            ? ObstetricalExamResultState.Normal
            : this.Result;
    }

    public setAbnormalResultIfNothingSet(): void {
        this.Result = !this.Result
            ? ObstetricalExamResultState.Abnormal
            : this.Result;
    }

    public setResult(result: ObstetricalExamResultState): void {
        this.Result = result;
    }

    public setExtraInfo(info: T): void {
        this.ExtraInfo = info;
        if (info)
            this.setAbnormalResultIfNothingSet();
    }
}

export { ObstetricalExamResultData };
